exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-type-container {\n  margin: 10px 10px;\n  flex: 0 0 40vw;\n}\n@media only screen and (max-width: 599px) {\n  .payment-type-container {\n    flex: 0 0 90vw;\n  }\n}\n\n.payment-image {\n  max-height: 80px;\n  width: auto;\n  max-width: 90%;\n  margin: auto;\n}\n.payment-image.extra-height {\n  max-height: 150px;\n}", ""]);

// exports
